export default __webpack_public_path__ + "static/media/commentSendButton.83e11216.svg";